import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { I18nContext } from 'translations';

const FormButton = ({
  expanded,
  setExpanded,
  fields,
  address,
  origin,
  addStops,
  showPackage,
  setShowPackage,
  isValid,
  step,
  setStep,
  setCustomer,
  paymentMethod,
  handleSubmit,
  submit,
  moneyBalance,
  setCounterDelivery,
  serviceByHours,
  scheduledAt,
  vehicleTypes,
  isReservation,
  getValues,
  watch,
  errors,
  loadingServiceTypes
}) => {
  const { translate } = useContext(I18nContext);
  const index = expanded.toString().match("stops(.*)") ? expanded.toString().match("stops(.*)")[1] : 0;
  const validPayment = paymentMethod !== "";
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    serviceByHours && setShowButton(true);
  }, [serviceByHours])

  return (
    <>
      {expanded === 'origin' ? (
        <Button
          type="button"
          size="large"
          color="primary"
          variant="contained"
          fullWidth
          style={{ borderRadius: '2px' }}
          onClick={() => {
            setCounterDelivery(moneyBalance);
            if (fields.length === 0) {
              return addStops()
            } else {
              return setExpanded('stops0')
            }
          }}
          disabled={(origin && origin.lat ? false : true) || (vehicleTypes === '' ? true : false) || !!loadingServiceTypes}
        >
          {translate('app.express.next')}
        </Button>
      ) :  expanded !== 'origin' && expanded !== 'close' ? (
        <>
          {!showPackage ? (
            <Button
              type="button"
              size="large"
              color="primary"
              variant="contained"
              fullWidth
              style={{ borderRadius: '2px' }}
              disabled={(fields.length > 0 && address && address[index] && address[index].lat && address[index].name ? false : true)}
              onClick={e => {
                e.preventDefault();
                setShowPackage(true);
                const section = document.querySelector( `#indications${index}` );
                section && setTimeout(() => { section.focus()}, 50);
              }}
            >
              {translate('app.express.next')}
            </Button>
          ) : (
            <Button
              type="button"
              size="large"
              color="primary"
              variant="contained"
              fullWidth
              style={{ borderRadius: '2px' }}
              disabled={(() => {
                const hasAddress = fields.length > 0 && address && address[index] && address[index].lat && address[index].name;
                if (!hasAddress) return true;

                const counterDelivery = watch(`stops[${index}].packages[0].counter_delivery`);
                if (counterDelivery) {
                  const collectedValue = watch(`stops[${index}].packages[0].collected_value`);
                  const hasError = errors?.stops?.[index]?.packages?.[0]?.collected_value;

                  if (hasError || !collectedValue || parseInt(collectedValue, 10) <= 0) {
                    return true;
                  }
                }

                return false;
              })()}
              onClick={e => {
                e.preventDefault();
                setExpanded('close');
                setShowPackage(false);
                setCustomer(false);
              }}
            >
              {translate('app.express.next')}
            </Button>
          )}
        </>
      ) : origin && origin.lat && fields.length > 0 && (
        <>
          {step === 0 ? (
            <Button
              type="button"
              size="large"
              color="primary"
              variant="contained"
              fullWidth
              style={{ borderRadius: '2px' }}
              disabled={!(origin && origin.lat && fields.length > 0 && address && address.length > 0)}
              onClick={async e => {
                e.preventDefault();
                setStep(1);
                const values = getValues();
                await submit(values, 1);
              }}
            >
              {translate('app.express.goPay')}
            </Button>
          ) : (step === 1 && serviceByHours && scheduledAt && showButton) ? (
            <Button
              type="button"
              size="large"
              color="primary"
              variant="contained"
              fullWidth
              style={{ borderRadius: '2px' }}
              disabled={!isValid}
              onClick={async e => {
                e.preventDefault();
                await handleSubmit((values) => submit(values, 1))()
                setShowButton(false)
              }}
            >
              {translate('recalculate')}
            </Button>
          ) : (
              <Button
                type="button"
                size="large"
                color="primary"
                variant="contained"
                fullWidth
                style={{ borderRadius: '2px' }}
                disabled={!(origin && origin.lat && fields.length > 0 && address && address.length > 0) || !validPayment || (isReservation && serviceByHours === undefined)}
                onClick={async e => {
                  e.preventDefault();
                  const values = getValues();
                  await submit(values, 0);
                }}
              >
                {isReservation ? translate('app.express.confirmServiceByHours') : translate('app.express.confirmService')}
              </Button>
          )}
        </>
      )}
    </>
  )
}

export default FormButton;